import * as Sentry from '@sentry/react';
import { SentryFallback } from '../components/UI/sentryFallback/SentryFallback';

interface FallbackProps {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError: () => void;
}
export default function SentryBoundaryFallback({ error, componentStack, eventId, resetError }: FallbackProps) {
  const ensuredId: string = eventId ?? Sentry.captureException(error);
  return <SentryFallback error={error} eventId={ensuredId} onRetry={resetError} />;
}
